import { getBackgroundColor } from 'src/core/domain/avatarColors';
import type {
  GetProfileSeekMaxQuery,
  GetUserQueryQuery,
  SeekMaxProfileQuery,
} from 'src/generated/gql/graphql';
import type { AppUserProfile } from 'src/types/userProfile';

export interface CareerHubProfile {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  jobTitle: string;
  hashcode: string;
  hashcodeInt: number;
}

export const generateUserProfileMapper = (
  queryResult: GetUserQueryQuery,
): AppUserProfile => {
  if (queryResult && queryResult.viewer) {
    const { id, emailAddress, personalDetails } = queryResult.viewer;
    return {
      id,
      email: emailAddress,
      firstName: personalDetails?.firstName || '',
      lastName: personalDetails?.lastName || '',
    };
  }
  return {
    id: 0,
    email: '',
    firstName: '',
    lastName: '',
  };
};

export interface SeekMaxProfile {
  email: string;
  firstName: string;
  lastName: string;
  jobTitle: string;
}

export const generateSeekMaxProfileMapper = (
  queryResult: GetProfileSeekMaxQuery,
): SeekMaxProfile => {
  if (queryResult && queryResult.viewer) {
    const { confirmedRoles, personalDetails, emailAddress } =
      queryResult.viewer;
    return {
      email: emailAddress,
      firstName: personalDetails?.firstName || '',
      lastName: personalDetails?.lastName || '',
      jobTitle: confirmedRoles?.[0]?.title.text || '',
    };
  }
  return {
    email: '',
    firstName: '',
    lastName: '',
    jobTitle: '',
  };
};

export interface LearningProfile {
  id: string;
  hashcode: string;
  hashcodeInt: number;
}

export const generateLearningProfileMapper = (
  queryResult: SeekMaxProfileQuery,
): LearningProfile => {
  if (queryResult && queryResult.seekMaxProfileV2) {
    const { learningProfileId, learningProfileHashCode } =
      queryResult.seekMaxProfileV2;
    return {
      id: learningProfileId,
      hashcode: getBackgroundColor(learningProfileHashCode),
      hashcodeInt: learningProfileHashCode,
    };
  }
  return {
    id: '',
    hashcode: getBackgroundColor(),
    hashcodeInt: 0,
  };
};
